enum ProjectOrderlineStatus {
  NotDefined = -``,
  NotScheduled = 0,
  InProgress = 1,
  OnHold = 2,
  Cancelled = 3,
  Completed = 4,
}
export default ProjectOrderlineStatus
